import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import Search from "./pages/Search";
import Food from "./pages/Food";
import { CartProvider } from "./context/CartContext";
import { Toaster } from "./components/ui/sonner";

export default function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <HashRouter>
        <CartProvider>
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
              <Route path="/search" element={<Search />} />
              <Route path="/food" element={<Food />} />
            </Routes>
          </div>
          <Footer />
          <Toaster position="top-center" richColors />
        </CartProvider>
      </HashRouter>
    </div>
  );
}
